var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"grad1","x1":"0%","y1":"0%","x2":"100%","y2":"0%"},[React.createElement("stop",{"offset":"0%","style":{"stopColor":"rgba(255,255,255,0)","stopOpacity":"1"},"key":0}),React.createElement("stop",{"offset":"100%","style":{"stopColor":"rgba(255,255,255,0.8)","stopOpacity":"1"},"key":1})])),React.createElement("path",{"d":"M0,10.69H33.68a10.53,10.53,0,0,0-5.3,9.11V20h1.39v-.2a9.12,9.12,0,0,1,9.1-9.11h.2V9.31h-.2A9.12,9.12,0,0,1,29.77.2V0H28.38V.2a10.53,10.53,0,0,0,5.3,9.11H0Z","key":1})]);
}

Arrow.defaultProps = {"viewBox":"0 0 39.48 20","width":"39.48","height":"20"};

module.exports = Arrow;

Arrow.default = Arrow;
